
export updateConversation = {
  "Peer conversation has already selected suggested dates": 'Your partner has already suggested some dates.'
}
